/**
 * 推送排障文档：路径、Cookie、锚点（与 packages/web/docs-content 内标题 id 一致）
 */

export const PUSH_TROUBLESHOOTING_SLUG = 'push-troubleshooting';

/** 文档语言偏好 Cookie，值为 zh | en */
export const DOCS_LANG_COOKIE = 'docs_lang';

export type DocsLangCode = 'zh' | 'en';

/** 中英 MD 中用于跳转的锚点 id（对应各节主标题） */
export const DOC_ANCHORS = {
    quickReference: 'quick-reference',
    silentAfterTotal: 'silent-after-total',
    rpcOr502: 'rpc-or-502',
    packfileTooLarge: 'packfile-too-large',
    unpackFailed: 'unpack-failed',
    progressivePush: 'progressive-push',
    pushDoctor: 'push-doctor',
    syncToGitflare: 'sync-to-gitflare',
    gitLfs: 'git-lfs',
} as const;

export function docsCanonicalPath(slug: string = PUSH_TROUBLESHOOTING_SLUG): string {
    return `/docs/${slug}`;
}

export function docsLocalizedPath(lang: DocsLangCode, slug: string = PUSH_TROUBLESHOOTING_SLUG): string {
    return `/docs/${lang}/${slug}`;
}

/**
 * 构建完整 HTTPS 帮助链接（供 Worker 错误体、邮件等使用）
 * @param baseOrigin 无前导路径的站点根，如 https://gitflare.org
 */
export function buildPushTroubleshootingUrl(baseOrigin: string, anchor?: string): string {
    const origin = baseOrigin.replace(/\/$/, '');
    const path = docsCanonicalPath();
    const u = `${origin}${path}`;
    return anchor ? `${u}#${anchor}` : u;
}
